import { AutogenLayoutMobileCommLoginLogoutHist } from "./autogen/AutogenLayoutMobileCommLoginLogoutHist";

export class MobileCommLoginLogoutHist extends AutogenLayoutMobileCommLoginLogoutHist {

    async onLoad() {
        // Default onLoad implementation
    }

    textboxLoginPositionIdBeforeLookupModelSearch(event) {
        event.filter.current_positions = true;
    }

    textboxLogoutPositionIdBeforeLookupModelSearch(event) {
        event.filter.current_positions = true;
    }
}
